/**
 * Master switch for the draw2text tool (writing on the plan, converted by
 * our own TrOCR model running in the browser).
 *
 * Turned off: recognition quality on real field handwriting was not good
 * enough to put in inspectors' hands, and the stylus-keyboard mode covers
 * the same need with the device's own recognizer. Everything is kept in
 * the codebase — dragger, worker, model fetch, onboarding — so flipping
 * this back to true restores the whole feature once the model improves.
 *
 * While false, nothing about it is visible or loaded: no toolbar button,
 * no settings row, and no model warmup at boot.
 */
export const HANDWRITING_TOOL_ENABLED = false;
